import React from 'react';

export default function createMetaComponent(
  {
    displayName,
    Component,
    defaultProps,
  },
) {
  const MetaComponent = React.forwardRef(
    (
      { className, as: Tag = Component || 'div', ...props },
      ref,
    ) => {
      return (
        <Tag
          ref={ref}
          className={className}
          {...props}
        />
      );
    },
  );
  MetaComponent.defaultProps = defaultProps;
  MetaComponent.displayName = displayName;
  return MetaComponent;
}